<app-header></app-header>
<div class="confirm-body h-100">
    <div class="row h-100 w-100 justify-content-center align-items-center m-0">
      <div class="card col-sm-10 col-md-8 col-lg-8 col-xl-6 p-3 m-3">
        <div class="row mx-auto w-100 my-3 image h-30">
            <!-- <img class="mx-auto h-100" src="assets/images/confirmed-mail.png"/> -->
            <ng-lottie class="mx-auto h-100"
                [options]="options" 
                (animationCreated)="animationCreated($event)">
            </ng-lottie>
        </div>
        <div class="row my-auto">
            <div class="row mx-auto w-100 p-3 align-items-center ">
                <h3 class="mt-3 mx-auto">{{ "AUTH.CONFIRM.CONFIRMED_TITLE" | translate}}</h3>
            </div>
            <div class="mx-auto p-3">
                <div class="inner-text m-auto align-items-center">
                    <h5 class="row w-100 mx-auto p-1 align-items-center">
                        <span>{{ 'AUTH.CONFIRM.HEY' | translate }} {{currentUser?.displayName}}! </span> {{ 'AUTH.CONFIRM.CONFIRMED_1' | translate}}
                    </h5>
                    <h5 class="row w-100 mx-auto p-1 align-items-center">
                        {{ 'AUTH.CONFIRM.CONFIRMED_2' | translate }} {{ 'AUTH.CONFIRM.CONFIRMED_3' | translate }} <span class="highlight mx-1">{{ currentUser?.email }}</span>.
                    </h5>
                    <h5 class="row w-100 mx-auto p-1 align-items-center">
                        {{ 'AUTH.CONFIRM.CONFIRMED_4' | translate }} 
                    </h5>
                </div>
                <div class="inner-text w-100  row m-auto p-1 align-items-center">
                    <h5 class="row mx-auto p-1 align-items-center">
                        {{ 'AUTH.CONFIRM.CONFIRMED_5' | translate }}  <a class="highlight link" (click)="sendAgain()"> {{ 'AUTH.CONFIRM.CONFIRMED_6' | translate }} </a>
                    </h5>
                </div>
            </div>
        </div>
        <div class="row mx-auto p-3">
            <div class="row">
                <button type="submit" (click)="backHome()" class="btn btn-primary w-100 p-2 mx-auto submit-btn">
                    {{ 'AUTH.CONFIRM.HOME' | translate }}
                </button>
            </div>
        </div>
    </div>   
    </div>
  </div>